export * from "./nurse-module.page";
export * from "./pages/nurse/nurse.page";
export * from "./pages/nurse-bed-view/nurse-bed-view.page";
export * from "./pages/in-patients-view/in-patients-view.page";
export * from "./pages/shifts/shifts.page";
export * from "./pages/actions/actions.page";
export * from "./pages/shift-assign/shift-assign.page";